module.exports = __webpack_public_path__ + "static/img/14.2609a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/14.png
// module id = fao8
// module chunks = 0